/**
 * Layer/reservoir attributes hidden from the UI (still stored in DB and sent via API when present).
 */
export const HIDDEN_LAYER_ATTRIBUTE_IDS = new Set([
  '50578fc1-0e9d-4d6d-bdd0-8516ecd9be35', // Reservoir type
  '9ea345e9-0281-41e7-b55f-aa80f52a4229', // Reservoir rock type
]);

export const HIDDEN_LAYER_ATTRIBUTE_NAMES = new Set([
  'Reservoir type',
  'Reservoir rock type',
]);

export function isHiddenLayerAttribute(
  attributeId?: string | null,
  attributeName?: string | null,
): boolean {
  if (attributeId && HIDDEN_LAYER_ATTRIBUTE_IDS.has(attributeId)) {
    return true;
  }
  if (attributeName && HIDDEN_LAYER_ATTRIBUTE_NAMES.has(attributeName)) {
    return true;
  }
  return false;
}

export function filterVisibleLayerAttributes<T>(
  items: T[],
  getId: (item: T) => string | null | undefined,
  getName: (item: T) => string | null | undefined,
): T[] {
  return items.filter((item) => !isHiddenLayerAttribute(getId(item), getName(item)));
}
